var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.449 10.9809L14.913 4.00493C15.0138 3.80304 15.1689 3.63324 15.3609 3.51456C15.5528 3.39587 15.774 3.33301 15.9997 3.33301C16.2253 3.33301 16.4465 3.39587 16.6385 3.51456C16.8304 3.63324 16.9855 3.80304 17.0863 4.00493L20.5503 10.9809L28.2943 12.1063C28.5177 12.1372 28.7279 12.2304 28.9008 12.3751C29.0738 12.5198 29.2026 12.7102 29.2725 12.9246C29.3425 13.139 29.3507 13.3687 29.2963 13.5875C29.242 13.8064 29.1271 14.0055 28.965 14.1623L23.3623 19.5889L24.685 27.2556C24.8543 28.2396 23.8143 28.9889 22.925 28.5249L15.9997 24.9036L9.073 28.5249C8.185 28.9903 7.145 28.2396 7.31433 27.2543L8.637 19.5876L3.03433 14.1609C2.87298 14.0041 2.75886 13.8051 2.70495 13.5867C2.65104 13.3682 2.6595 13.139 2.72936 12.9251C2.79922 12.7112 2.92769 12.5212 3.10016 12.3767C3.27263 12.2322 3.48218 12.139 3.705 12.1076L11.449 10.9809Z",
    stroke: "#383838",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.29c79c173dea150cb6e195d49f84d4cf.svg";
export { ForwardRef as ReactComponent };